
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import CTAButton from '@/components/CTAButton';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import SectionLayout from '@/components/SectionLayout';

const BookDemo = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        {/* Hero Section */}
        <SectionLayout 
          paddingY="pt-32 pb-8"
          backgroundColor="bg-white"
        >
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-[#003a70]">
              Book a Live Demo
            </h1>
            <p className="text-lg md:text-xl mb-4 text-gray-700 max-w-2xl mx-auto">
              See how AskSpot can transform your customer interactions with a personalized demonstration from our team.
            </p>
          </div>
        </SectionLayout>

        {/* Calendar Section - Using SectionLayout for better structure */}
        <SectionLayout 
          backgroundColor="bg-gradient-to-b from-white to-[#FEE6D8]/20"
          paddingY="py-8"
        >
          <div className="w-full max-w-5xl mx-auto">
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md">
              {/* Calendar embed with fixed height set to fully contain the content */}
              <iframe 
                src="https://tidycal.com/askspot/askspot-onboarding-1rydenz" 
                frameBorder="0" 
                style={{ 
                  width: '100%', 
                  height: '1200px', // Significantly increased height to ensure full calendar display
                  border: 'none',
                  overflow: 'visible'
                }}
                title="Book a Demo with AskSpot"
                loading="eager"
                allow="camera *; microphone *; autoplay *; clipboard-write *; encrypted-media *; fullscreen *; picture-in-picture *"
              ></iframe>
            </div>
          </div>
        </SectionLayout>

        {/* Additional Info Section */}
        <SectionLayout 
          paddingY="py-16"
          backgroundColor="bg-white"
        >
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-[#003a70]">
              What to Expect
            </h2>
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <Card className="overflow-hidden border-0 shadow-lg transition-all hover:shadow-xl">
                <div className="bg-[#003a70]/5 p-5 flex justify-center">
                  <div className="w-12 h-12 bg-[#003a70] rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-xl">1</span>
                  </div>
                </div>
                <CardContent className="pt-6">
                  <h3 className="font-semibold text-lg mb-3 text-[#003a70]">Product Walkthrough</h3>
                  <p className="text-gray-600">A comprehensive tour of AskSpot's features and capabilities tailored to your business needs.</p>
                </CardContent>
              </Card>
              
              <Card className="overflow-hidden border-0 shadow-lg transition-all hover:shadow-xl">
                <div className="bg-[#003a70]/5 p-5 flex justify-center">
                  <div className="w-12 h-12 bg-[#003a70] rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-xl">2</span>
                  </div>
                </div>
                <CardContent className="pt-6">
                  <h3 className="font-semibold text-lg mb-3 text-[#003a70]">Use Case Discussion</h3>
                  <p className="text-gray-600">Exploration of how AskSpot fits your specific business needs and workflow integration.</p>
                </CardContent>
              </Card>
              
              <Card className="overflow-hidden border-0 shadow-lg transition-all hover:shadow-xl">
                <div className="bg-[#003a70]/5 p-5 flex justify-center">
                  <div className="w-12 h-12 bg-[#003a70] rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-xl">3</span>
                  </div>
                </div>
                <CardContent className="pt-6">
                  <h3 className="font-semibold text-lg mb-3 text-[#003a70]">Q&A Session</h3>
                  <p className="text-gray-600">Get answers to all your questions from our product experts and implementation specialists.</p>
                </CardContent>
              </Card>
            </div>
            <Link to="/contact">
              <CTAButton variant="secondary" className="mx-auto">
                Have questions? Contact us
              </CTAButton>
            </Link>
          </div>
        </SectionLayout>
      </main>
      <Footer />
    </div>
  );
};

export default BookDemo;
